import { render, staticRenderFns } from "./VCard.vue?vue&type=template&id=5a987bc4&scoped=true"
import script from "./VCard.vue?vue&type=script&lang=js"
export * from "./VCard.vue?vue&type=script&lang=js"
import style0 from "./VCard.vue?vue&type=style&index=0&id=5a987bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a987bc4",
  null
  
)

export default component.exports